<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <create-reportdept></create-reportdept>
    </div>
  </div>
</template>

<script>
import CreateReportdept from "../../components/CreateReportdept.vue";
// import YimoVueEditor from "yimo-vue-editor/src/Editor";

export default {
  components: {
    CreateReportdept,
    // hexToRgba,
    // CustomTooltips,
  },
  // extends: Line,

  name: "Reportdept",
  data() {
    return {
      items: [],
      categorey: []
    };
  },
  methods: {},
  mounted() {
  },
  created() {
  }
};
</script>
<style></style>
